import { KeyFunctionMap, RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"

//region Types

export interface ExampleItemDocumentProperties {
  id: string
  name: string
  description?: string
  properties?: Record<string, string>
}

export interface ExampleItemDocumentMethods extends KeyFunctionMap {
  getTitle: () => string
}

export type ExampleItemDocument = RxDocument<
  ExampleItemDocumentProperties,
  ExampleItemDocumentMethods
>

export interface ExampleItemCollectionMethods extends KeyFunctionMap {
  countAllDocuments: () => Promise<number>
}

export type ExampleItemCollection = RxCollection<
  ExampleItemDocumentProperties,
  ExampleItemDocumentMethods,
  ExampleItemCollectionMethods
>

//endregion

/**
 * Schema for ExampleItem collections.
 */
export const exampleItemSchema: RxJsonSchema<ExampleItemDocumentProperties> = {
  title: "ExampleItem schema",
  description: "Example items to demonstrate with",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 100 },
    name: { type: "string", maxLength: 100 },
    description: { type: "string" },
    properties: {
      type: "object",
      additionalProperties: true,
    },
  },
  required: ["id", "name"],
  indexes: ["name"],
}

/**
 * Implementation of ExampleItem document methods.
 */
export const exampleItemDocumentMethods: ExampleItemDocumentMethods = {
  getTitle(this: ExampleItemDocument): string {
    return `${this.id}: ${this.name}`
  },
}

/**
 * Implementation of ExampleItem Collection methods.
 */
export const exampleItemCollectionMethods: ExampleItemCollectionMethods = {
  async countAllDocuments(this: ExampleItemCollection) {
    const allDocs = await this.find().exec()
    return allDocs.length
  },
}

/**
 * A collection creator that can be passed to the database when setting up collections.
 */
export const exampleItemCollectionCreator: RxCollectionCreator = {
  schema: exampleItemSchema,
  methods: exampleItemDocumentMethods,
  statics: exampleItemCollectionMethods,
}
